import scaleD from '../lib/scaleD.js';
import Base from '../lib/LdrsBaseElement.js';
import styles from './squircle.scss';
class Squircle extends Base {
    _attributes = [
        'size',
        'color',
        'speed',
        'stroke',
        'stroke-length',
        'bg-opacity',
    ];
    size;
    color;
    speed;
    stroke;
    'stroke-length';
    'bg-opacity';
    d;
    static get observedAttributes() {
        return ['size', 'color', 'speed', 'stroke', 'stroke-length', 'bg-opacity'];
    }
    constructor() {
        super();
        this.storePropsToUpgrade(this._attributes);
        this.reflect(this._attributes);
        this.d =
            'M0.5,25C0.5,7.8,7.8,0.5,25,0.5S49.5,7.8,49.5,25S42.2,49.5,25,49.5S0.5,42.2,0.5,25';
    }
    connectedCallback() {
        this.upgradeStoredProps();
        this.applyDefaultProps({
            size: 37,
            color: 'black',
            stroke: 5,
            'stroke-length': 0.15,
            speed: 0.9,
            'bg-opacity': 0.1,
        });
        const scaledD = scaleD(parseInt(this.size) / 50, this.d);
        this.template.innerHTML = `
      <svg
        class="container" 
        x="0px" 
        y="0px"
        viewBox="0 0 ${this.size} ${this.size}"
        height="${this.size}"
        width="${this.size}"
        preserveAspectRatio='xMidYMid meet'
      >
        <path
          class="track" 
          fill="none" 
          stroke-width="${this.stroke}" 
          pathlength="100"
          d="${scaledD}"
        />

        <path
          class="car" 
          fill="none" 
          stroke-width="${this.stroke}" 
          pathlength="100"
          d="${scaledD}"
        />
      </svg>
      <style>
        :host{
          --uib-size: ${this.size}px;
          --uib-color: ${this.color};
          --uib-speed: ${this.speed}s;
          --uib-dash: ${parseFloat(this['stroke-length']) * 100};
          --uib-gap: ${100 - parseFloat(this['stroke-length']) * 100};
          --uib-bg-opacity: ${this['bg-opacity']};
        }
        ${styles}
      </style>
    `;
        this.shadow.replaceChildren(this.template.content.cloneNode(true));
    }
    attributeChangedCallback() {
        const styleEl = this.shadow.querySelector('style');
        const svgEl = this.shadow.querySelector('svg');
        const pathEls = this.shadow.querySelectorAll('path');
        if (!styleEl)
            return;
        svgEl.setAttribute('height', this.size);
        svgEl.setAttribute('width', this.size);
        svgEl.setAttribute('viewBox', `0 0 ${this.size} ${this.size}`);
        pathEls.forEach((pathEl) => {
            pathEl.setAttribute('stroke-width', this.stroke);
            pathEl.setAttribute('d', scaleD(parseInt(this.size) / 50, this.d));
        });
        styleEl.innerHTML = `
      :host{
        --uib-size: ${this.size}px;
        --uib-color: ${this.color};
        --uib-speed: ${this.speed}s;
        --uib-dash: ${parseFloat(this['stroke-length']) * 100};
        --uib-gap: ${100 - parseFloat(this['stroke-length']) * 100};
        --uib-bg-opacity: ${this['bg-opacity']};
      }
      ${styles}
    `;
    }
}
export default {
    register: (name = 'l-squircle') => {
        if (!customElements.get(name)) {
            customElements.define(name, class extends Squircle {
            });
        }
    },
    element: Squircle,
};
